import './AppTemplate.css'

import { compose, withProps, withState } from 'recompose'
import { Link, withRouter } from 'react-router-dom'
import React from 'react'
import AppBar from 'material-ui/AppBar'
import Drawer from 'material-ui/Drawer'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import muiThemeable from 'material-ui/styles/muiThemeable'
import { negate } from 'lodash'

import NewVersionPrompt from './NewVersionPrompt'
import {
  aboutRoute,
  indexRoute,
  programRoute,
  reportProblemRoute,
  sponsorsRoute,
  trackRoute,
  venueRoute,
  standsRoute,
  informationRoute,
  workshopsRoute,
} from '../app/routes'
import { getAppTitle, getNavigationLabels, getTracks } from '../app/selectors'
import { withSizes } from '../app/utils'
import content from '../content'
import { isTrackCrossTrack, isTrackWorkshop } from '../app/predicates'

const isTrackNonWorkshop = negate(isTrackWorkshop)

// disable swipe of drawer as swipe is also used for back (e.g. iOS)
const DISABLE_SWIPE = true

const TrackItem = ({ color, label }) => (
  <div className="AppTemplate-TrackItem-container">
    <div
      style={{ backgroundColor: color }}
      className="AppTemplate-TrackItem-icon"
    />
    {label}
  </div>
)

const titleStyle = {
  cursor: 'pointer',
}

const AppTemplate = ({
  isDrawerOpen,
  setDrawerOpen,
  children,
  location,
  title,
  isDesktop,
  navigationLabels,
  tracks,
  muiTheme,
  history,
}) => {
  const openDrawer = () => setDrawerOpen(true)
  const closeDrawer = () => setDrawerOpen(false)
  const { backgroundColor } = muiTheme.custom.colors
  const {
    appBar: { height: appBarHeight },
    custom: { metrics: { basePadding, maxContentWidth } },
  } = muiTheme
  const contentStyle = {
    margin: isDesktop ? '0 0 0 280px' : '0',
    padding: basePadding,
    paddingTop: appBarHeight + basePadding,
    maxWidth: maxContentWidth,
  }
  const navigateHome = () => history.push(indexRoute)
  return (
    <div className="AppTemplate-container" style={{ backgroundColor }}>
      <AppBar
        title={title}
        onTitleClick={navigateHome}
        titleStyle={titleStyle}
        onLeftIconButtonClick={openDrawer}
        style={{ position: 'fixed' }}
      />
      <div className="AppTemplate-content" style={contentStyle}>
        {children}
      </div>
      <Drawer
        open={isDesktop || isDrawerOpen}
        docked={isDesktop}
        containerStyle={{ overflow: 'hidden', backgroundColor }}
        onRequestChange={open => setDrawerOpen(open)}
        disableSwipeToOpen={DISABLE_SWIPE}
      >
        <AppBar
          title={title}
          onTitleClick={navigateHome}
          titleStyle={titleStyle}
          showMenuIconButton={!isDesktop}
          onLeftIconButtonClick={closeDrawer}
        />
        <Menu value={location.pathname} onItemClick={closeDrawer}>
          <MenuItem
            value={programRoute}
            containerElement={<Link to={programRoute} />}
            primaryText={navigationLabels.lectures}
          />
          {tracks
            .filter(negate(isTrackCrossTrack))
            .filter(isTrackNonWorkshop)
            .map(t => (
              <MenuItem
                key={t.id}
                style={{ paddingLeft: 20 }}
                value={trackRoute(t.id)}
                containerElement={<Link to={trackRoute(t.id)} />}
              >
                <TrackItem color={t.color} label={t.label} />
              </MenuItem>
            ))}
          <MenuItem
            value={workshopsRoute}
            containerElement={<Link to={workshopsRoute} />}
            primaryText={navigationLabels.workshops}
          />
          {tracks
            .filter(negate(isTrackCrossTrack))
            .filter(isTrackWorkshop)
            .map(t => (
              <MenuItem
                key={t.id}
                style={{ paddingLeft: 20 }}
                value={trackRoute(t.id)}
                containerElement={<Link to={trackRoute(t.id)} />}
              >
                <TrackItem color={t.color} label={t.label} />
              </MenuItem>
            ))}
          <MenuItem
            value={venueRoute}
            containerElement={<Link to={venueRoute} />}
            primaryText={navigationLabels.venue}
          />
          <MenuItem
            value={aboutRoute}
            containerElement={<Link to={aboutRoute} />}
            primaryText={navigationLabels.about}
          />
          <MenuItem
            value={sponsorsRoute}
            containerElement={<Link to={sponsorsRoute} />}
            primaryText={navigationLabels.sponsors}
          />
          <MenuItem
            value={standsRoute}
            containerElement={<Link to={standsRoute} />}
            primaryText={navigationLabels.stands}
          />
          <MenuItem
            value={informationRoute}
            containerElement={<Link to={informationRoute} />}
            primaryText={navigationLabels.information}
          />
          <MenuItem
            value={reportProblemRoute}
            containerElement={<Link to={reportProblemRoute} />}
            primaryText={navigationLabels.reportProblem}
          />
        </Menu>
      </Drawer>
      <NewVersionPrompt />
    </div>
  )
}

const withDrawerState = withState('isDrawerOpen', 'setDrawerOpen', false)
const withPageContent = withProps({
  title: getAppTitle(content),
  navigationLabels: getNavigationLabels(content),
  tracks: getTracks(content),
})

export default compose(
  withRouter,
  withDrawerState,
  withPageContent,
  withSizes(),
  muiThemeable()
)(AppTemplate)



// WEBPACK FOOTER //
// ./src/components/AppTemplate.js